/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Prize pool breakdown in financials response
 * @export
 * @interface FinancialsPrizePool
 */
export interface FinancialsPrizePool {
    /**
     * 
     * @type {number}
     * @memberof FinancialsPrizePool
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialsPrizePool
     */
    distributed?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialsPrizePool
     */
    remaining?: number;
}

/**
 * Check if a given object implements the FinancialsPrizePool interface.
 */
export function instanceOfFinancialsPrizePool(value: object): value is FinancialsPrizePool {
    return true;
}

export function FinancialsPrizePoolFromJSON(json: any): FinancialsPrizePool {
    return FinancialsPrizePoolFromJSONTyped(json, false);
}

export function FinancialsPrizePoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialsPrizePool {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'distributed': json['distributed'] == null ? undefined : json['distributed'],
        'remaining': json['remaining'] == null ? undefined : json['remaining'],
    };
}

export function FinancialsPrizePoolToJSON(json: any): FinancialsPrizePool {
    return FinancialsPrizePoolToJSONTyped(json, false);
}

export function FinancialsPrizePoolToJSONTyped(value?: FinancialsPrizePool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'distributed': value['distributed'],
        'remaining': value['remaining'],
    };
}

